import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Text,
	Button,
	List, ListItem,
	Stack,
	Radio,
	Divider
} from '@chakra-ui/react'
import { RxCaretSort } from "react-icons/rx";
import { Reorder } from "framer-motion";
import { SelectField, CheckboxInput } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

import {
	Formik,
	Form,
} from 'formik';
import { RadioGroupControl } from 'formik-chakra-ui';

function Otp({ customer_id, message_type_id, }) {
	const [channelList, setChannelList] = useState([])
	const [channelListDropDown, setChannelListDropDown] = useState([])
	const [methodData, setMethodData] = useState([])
	const [formData, setFormData] = useState({
		message_type_id: 1,
		customer_id: customer_id,
		method: 'smart',
		sent_other_channel: '',
		sent_other_channel_id: '',
		custom_route_order: ''

	});

	useEffect(() => {

		loadRouteMethod()

	}, [customer_id, message_type_id])


	const loadRouteMethod = async () => {

		const url = `${process.env.REACT_APP_API_URL}/route_method/list-by-customer?customer_id=${customer_id}&message_type_id=1`;
		const data = await fetchWrapper.get(url)




		if (data.data) {

			setFormData({
				message_type_id: 1,
				customer_id: customer_id,
				method: data.data.method,
				sent_other_channel: data.data.sent_other_channel == 1 ? true : false,
				sent_other_channel_id: data.data.sent_other_channel_id,
				custom_route_order: ''

			})
			if (data.data.method === 'custom') {

				const savedValue = JSON.parse(data.data.custom_route_order);

				const orgValue = data.channel_list;

				// Step 1: Filter out items in savedValue that are not in orgValue
				const orgIds = orgValue.map(item => item.id);
				let updatedSavedValue = savedValue.filter(item => orgIds.includes(item.id));

				// Step 2: Add items from orgValue that don't exist in updatedSavedValue
				orgValue.forEach(orgItem => {
					if (!updatedSavedValue.some(savedItem => savedItem.id === orgItem.id)) {
						updatedSavedValue.push({ id: orgItem.id, name: orgItem.name });
					}
				});



				setChannelList(updatedSavedValue);

			} else {
				setChannelList(data.channel_list)
			}


		} else {

			setFormData({
				message_type_id: 1,
				customer_id: customer_id,
				method: 'smart',
				sent_other_channel: '',
				sent_other_channel_id: '',
				custom_route_order: ''

			})
			setChannelList(data.channel_list)


		}
		setMethodData(data.data)

		loadList(data.channel_list)
	}

	const loadList = async (list) => {
		const listValue = list.map(cRs => {
			return { id: cRs.id, name: cRs.name }
		})


		setChannelListDropDown({ data: listValue });


	}

	const FormSchema = Yup.object().shape({
		// method: Yup.string().required('Required'),
	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values
		let url = `${process.env.REACT_APP_API_URL}/route_method/create`;
		if (methodData) {
			url = `${process.env.REACT_APP_API_URL}/route_method/update`;
			data.id = methodData.id
		}

		const custom_route_order = channelList
		if (data.method === 'custom') {
			data.custom_route_order = custom_route_order

		}
		if (!data.sent_other_channel) {
			data.sent_other_channel_id = 0;
		}
		await fetchWrapper.post(url, data)
		toast(`Record has been saved `, {
			type: "info"
		});
	}

	const typeList = [
		{ id: 'smart', name: 'Smart Routing', description: "Smart Routing identifies the most cost-effective communication channel by evaluating the notification’s price and destination country, ensuring optimal cost and delivery efficiency." },

	]
	const typeListCustom = [
		{ id: 'custom', name: 'Custom Routing', description: "Custom Routing enables customers to configure notification paths based on the type of notification. In the event of a failure, the system automatically reroutes the notification to the next preferred channel, ensuring seamless and reliable delivery." },

	]
	return (
		<Formik
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			{({
				setFieldValue,
				setFieldTouched,
				values,
				errors,
				touched,
			}) => (
				<Form>
					<Box mb="10px" className='routes'>
						<RadioGroupControl name="method" defaultValue="smart">
							<Stack spacing={4} direction="column" >
								{typeList.map((type) => (
									<Box key={type.id} divideY="2px" style={{ border: "1px solid #CCCCCC", padding: "10px 15px", borderRadius: "5px" }}>
										<Radio value={type.id}>{type.name}</Radio>
										<Text fontSize="sm" color="gray.600" ml={6}>
											{type.description}
										</Text>
									</Box>
								))}
							</Stack>
						</RadioGroupControl>
					</Box>

					<Box mb="10px" className='routes'>
						<RadioGroupControl name="method" defaultValue="smart" >
							<Stack spacing={4} direction="column" >
								{typeListCustom.map((type) => (

									<Box key={type.id} divideY="2px" style={{ border: "1px solid #CCCCCC", padding: "10px 15px", borderRadius: "5px" }}>
										<Radio value={type.id} >{type.name}</Radio>
										<Text fontSize="sm" color="gray.600" ml={6}>
											{type.description}
										</Text>
										<br />
										{values.method === 'custom' && (
											<>
												<Divider />
												<br />
												<Text fontSize="sm" color="gray.600" style={{ marginBottom: "1rem" }}>
													Please drag and drop to rearrange the order
												</Text>
											</>
										)}
										{values.method === 'custom' &&
											<Box className='dragable_list'>
												<List
													as={Reorder.Group}
													axis="y"
													values={channelList}
													onReorder={setChannelList}
													spacing={5}
												>
													{channelList?.map((item) => (
														<ListItem
															as={Reorder.Item}
															key={item.id}
															value={item}
															px={3}
															py={2}
															style={{ border: "1px solid #CCCCCC", borderRadius: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
															rounded="xl"
														>
															<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																<RxCaretSort size={30} />	{item.name}
															</div>
															<Text fontSize="sm" style={{ color: "#7C7C7C" }}>
																Fixed Cost Globally
															</Text>
														</ListItem>
													))}
												</List>
											</Box>
										}
									</Box >
								))}
							</Stack>
						</RadioGroupControl>
					</Box>
					{/* <Box>
						<CheckboxInput title="Also send this Notification to" name="sent_other_channel" style={{ fontWeight: "500" }} />
						<Text fontSize="sm" px={6} mb={2}>
							In addition to the primary notification, this will also be sent through the specified channel, triggering notifications across two channels simultaneously.
						</Text>
					</Box> */}
					{values.sent_other_channel &&
						<Box>
							<SelectField name="sent_other_channel_id" list={channelListDropDown} title="Channel List" />
						</Box>
					}
					<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
						mb={4}

						type='submit'
					>
						Update Settings
					</Button>
				</Form>
			)}
		</Formik >
	)
}

export default Otp;